import Vue from "vue"
import Router from "vue-router"
import { commonRouter } from "./router"
import store from "@/store"
Vue.use(Router)

const router = new Router({
  mode: "hash",
  routes: commonRouter,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  // if (to.path === "/login") {
  //   next()
  // } else {
  //   if (Vue.$cookies.get("admin_token")) {
  //     next()
  //   } else {
  //     console.log("无token")
  //     next({ path: "/login" })
  //   }
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js